import React from 'react';
import { Button } from './Button';
const PartnerPromotion = () => {
  return <div className="bg-background-neutral-soft dark:bg-dark-background-neutral-soft rounded-lg p-6 my-4 text-center md:hidden" data-id="element-80">
      <div className="flex justify-center mb-3" data-id="element-81">
        <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
        backgroundColor: '#CFE3E6'
      }} data-id="element-82">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ufLY3y4gAaF9FRZNSd4q9g/Signal_AI.svg" alt="Signal AI" className="w-5 h-5" data-id="element-83" />
        </div>
      </div>
      <h3 className="text-base font-medium mb-3 dark:text-dark-text" data-id="element-84">
        Want to list your AI tool?
      </h3>
      <a href="https://forms.office.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbR6fDoxh-HzVGmyoQOI03pZNUQTRLTlhJSkk2WVZZUjNVMDNNWENQQzZUNi4u&route=shorturl" target="_blank" data-id="element-85">
        <Button type="secondary" size="small" data-id="element-86">
          Become a partner
        </Button>
      </a>
    </div>;
};
export default PartnerPromotion;